"use client"
import styled from "styled-components";
import Link from 'next/link';
import { theme } from '@/components/features/theme/theme';
import ReactHtmlParser from 'react-html-parser';
import { ImgParallax } from '@/components/common/ui/images/ImgParallax';
import { Img } from '@/components/common/ui/images/Img';
import { CURSOR_TEXT, DispatchCursor } from 'haspr-cursor';

const IndustrySingle = ({title, link,  count, img}) => {

	const dispatch = DispatchCursor()
	
	// Extract clean text from title for alt attribute
	const cleanTitle = typeof title === 'string' 
		? title.replace(/<[^>]*>/g, '').trim()
		: (Array.isArray(title) 
			? title.map(t => typeof t === 'string' ? t : '').join('').replace(/<[^>]*>/g, '').trim()
			: '');
	
	const altText = cleanTitle || 'Industry';
	
	// Check if the media is a video
	const isVideo = img && (img.includes('.mp4') || img.includes('.webm') || img.includes('.ogg'));

	return (
		<StyledIndustrySingle className='IndustrySingle' onMouseEnter={() => CURSOR_TEXT(dispatch, 'View Industry')} onMouseLeave={() => CURSOR_TEXT(dispatch, 'END')}>
			<div className="IndustrySingle__inner">
				{
					link &&
					<Link prefetch={true} href={link || '/blog/slug'} aria-label={altText}></Link>
				}
				
				{isVideo ? (
					<div className="video-wrapper">
						<video 
							autoPlay 
							muted 
							loop 
							playsInline
							style={{ width: '100%', height: '100%', objectFit: 'cover' }}
							aria-label={altText}
						>
							<source src={img} type="video/mp4" />
							{/* Fallback text for browsers that don't support video */}
							<p>{altText}</p>
						</video>
						{/* Overlay gradient for video */}
						<div className="video-overlay"></div>
					</div>
				) : (
					<Img src={img} objectFit={'cover'} alt={altText} layout={'fill'}/>
				)}
				
				<div className="IndustrySingle__inner__content">
					<h6 className={''}>{title}</h6>
				</div>
				<div className="IndustrySingle__inner__count">
					<p className={''}>{count}</p>
				</div>
			</div>
		</StyledIndustrySingle>
	);
};

const StyledIndustrySingle = styled.div`
    //width: 100%;

    .IndustrySingle__inner {
        padding-top: calc(420 / 270 * 100%);
        position: relative;
        border-radius: 5px;
        overflow: hidden;
        cursor: pointer;

        .video-wrapper {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            z-index: 0;
            
            video {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                object-fit: cover;
                transition: ${theme.transition};
                transform: scale(1.01);
            }
            
            .video-overlay {
                position: absolute;
                left: 0;
                right: 0;
                top: 0;
                bottom: 0;
                background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.7) 100%);
                width: 100%;
                height: 100%;
                pointer-events: none;
                z-index: 1;
            }
        }

        .global-image {
            transition: ${theme.transition};
            transform: scale(1.01);
            &:after{
                content: '';
                position: absolute;
                left: 0;
                right: 0;
                top: 0;
                bottom: 0;
                background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.7) 100%);
                width: 100%;
                height: 100%;
            }
        }

        a {
            position: absolute;
            height: 100%;
            width: 100%;
            left: 0;
            top: 0;
            z-index: 3;
        }

        &__content {
            position: absolute;
            left: 0;
            right: 0;
            bottom: 70px;
            display: flex;
            justify-content: center;
            padding: 0 10px;
            z-index: 2;

            h6 {
                color: ${theme.colors.themeColor50};
                font-weight: 500;
                font-size: 1.25rem; /* 20px converted to rem */
                line-height: 1.75rem; /* 28px converted to rem */
                letter-spacing: 0; /* No letter spacing */
                text-align: center; /* Center align text */
                min-height: 56px;
                display: flex;
                align-items: center;
                justify-content: center;
                transition: ${theme.transition};
                transition-delay: 0.3s;
                @media (min-width: 1336px) {
                    width: 69%;
                }
            }
        }

        &__count {
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            text-align: center;
            z-index: 1;

            p {
                color: rgba(228, 224, 219, 0.30);
                text-align: center;
                font-size: 10rem; /* 160px converted to rem */
                font-style: normal;
                font-weight: 500;
                line-height: normal;
                transition: ${theme.transition};
                transition-delay: 0.3s;
            }
        }

        &:hover {
            .global-image {
                transform: scale(1.04);
            }
            
            .video-wrapper video {
                transform: scale(1.04);
            }

            h6 {
                    //color: ${theme.colors.hover};
            }

            p {
                color: rgba(237, 32, 36, 0.3);
            }
        }

    }




`;
export default IndustrySingle;
